import * as React from 'react';

import styled from 'styled-components';

import { getFontFamily } from 'services/FontService';
import { Colors } from 'services/ColorService';

export interface IUserInfoProps {
  firstName?: string | null;
  lastName?: string | null;
  email?: string | null;
}

export const UserInfo = ({ firstName, lastName, email }: IUserInfoProps) => {
  const fullName = [firstName, lastName].filter(Boolean).join(' ').trim();

  if (!fullName && !email) {
    return null;
  }

  return (
    <Wrapper>
      {fullName ? (
        <>
          <Name>{fullName}</Name>
          {email ? <Email>{email}</Email> : null}
        </>
      ) : (
        <Name>{email}</Name>
      )}
    </Wrapper>
  );
};

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-end;
  text-align: right;
  line-height: 1.2;
`;

const Name = styled.span`
  font-family: ${getFontFamily('bold')};
  font-weight: bold;
  font-size: 14px;
  letter-spacing: 0.5px;
  color: ${Colors.Black};
`;

const Email = styled.span`
  font-size: 12px;
  color: ${Colors.Gray};
  margin-top: 2px;
`;
